<template>
    <button class="mg-btn-gold" color="primary" text-color="whiteprimary"  v-on:click="modalOpen">Add Customer</button>    
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#customerModals" id="addCustomerBtn"> </button>             
    <div class="modal fade right" id="customerModals" tabindex="-1" style="display: none;" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">            
            <div class="modal-content">
                <div class="modal-header">
                    <input type="hidden" name="customerEditId" id="customerEditId">
                    <h5 class="modal-title">{{ modalType }} Customer</h5> 
                    <button type="button" class="btn-close" id="closePop" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <form @submit.prevent="onSubmit" class="customerFrm" id="customerFrm">
                    <div class="modal-body setformbackform">
                        <div class="row">
                            <div class="col-sm-12">
                                <span v-if="errorMessage != ''">
                                    <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                                </span>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="user_id" class="form-label">Name<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="user_id" id="user_id" placeholder="Enter customer name"  v-model="v$.form.user_id.$model"> 
                                    <div class="input-errors" v-for="(error, index) of v$.form.user_id.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="mpin" class="form-label">Pin<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="mpin" id="mpin" placeholder="Enter pin"  v-model="v$.form.mpin.$model" > 
                                    <div class="input-errors" v-for="(error, index) of v$.form.mpin.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="modal-footer">                           
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-on:click="addCustomer" v-if="formLoader === 1">{{ buttonName }}</button>
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                
                </form>
            </div>
        </div>
    </div>

</template>
<script>
import useVuelidate from '@vuelidate/core'
import {
    required,
    // maxLength,
    helpers,
    minLength
} from '@vuelidate/validators'
import $ from "jquery";
import axios from 'axios'
// const onlyDigits = helpers.regex('onlyFourDigits', /^[0-9]+$/);
// const onlyDigits = helpers.withMessage(
//   'Input must be exactly 4 numeric digits.',
//   helpers.regex('onlyFourDigits', /^\d{4}$/)
// );

const onlyDigits = helpers.withMessage(
  'Input must be exactly 4 numeric digits.',
  (value) => {
    if (!value) return false; // Ensure value exists
    const trimmedValue = value.trim();
    return /^\d{4}$/.test(trimmedValue); // Check for exactly 4 digits
  }
);

export default {
    name: 'AddEditCustomer',
    emits: ['reloadTableData'], 
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            modalType: 'Add',
            buttonName: 'Save',
            errorMessage: '',
            formLoader: 1,
            logoFile: null,
            form: {
                user_id: '',
                mpin: '',
            },
        }
    },
    methods: {
        async modalOpen() {
            this.errorMessage = ''
            this.form.user_id = '';
            this.form.mpin = '';
            
            this.modalType = 'Add';
            this.buttonName = 'Save',
            this.logoFile = null,
            this.v$.$reset()
            document.getElementById('customerEditId').value = '';
            document.getElementById('addCustomerBtn').click();
            setTimeout(async () =>
                $("#user_id").focus(),
            500);
        },
        async addCustomer() {
            this.formLoader = 2
            let _post = {}
            let _URL = ''
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            var user_id = $('#user_id').val();
            var mpin = $('#mpin').val();
            if (this.modalType == 'Edit') {
                _URL = process.env.VUE_APP_API_URL + 'customers/update'
                var customer_id = $('#customerEditId').val();
                _post = {
                    customer_id: customer_id,
                    user_id: user_id,
                    mpin: mpin,
                }
            } else {
                _URL = process.env.VUE_APP_API_URL + 'customers/create'
                _post = {
                    user_id: user_id,
                    mpin: mpin,
                }
            }
            await axios.post(_URL, _post)
                .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closePop').click();
                    this.$toast.success(resp.data.message);
                    this.$store.state.priority.loadPriorityData = 1
                    this.$emit('reload-table-data');
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                }
                    this.formLoader = 1
            })
                .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.errorRes = error.response.data.message;
                this.formLoader = 1
            })            
        },
        async modalEditOpen() {
            let customer_id = $('.customerValId').val();
            let userMpin = $('.userMpin').val();
            let userName = $('.userName').val();
            $('.loadimg').show();
            this.errorMessage = ''
            this.form.user_id = userName;
            this.form.mpin = userMpin;
            document.getElementById('customerEditId').value = customer_id;
            this.modalType = 'Edit',
            this.buttonName = 'Update',
            document.getElementById('addCustomerBtn').click();
            this.v$.$reset()
        },
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                user_id: {
                    required,
                    min: minLength(2)
                },
                mpin: {
                    required,              // Field is mandatory
                    // minLength: minLength(4), // Minimum length of 4
                    // maxLength: maxLength(4), // Maximum length of 4
                    onlyDigits,     
                },
            },
        }
    },
}
</script>